import { render, staticRenderFns } from "./IntegrationsSettings.vue?vue&type=template&id=57d128ce&scoped=true&"
import script from "./IntegrationsSettings.vue?vue&type=script&lang=js&"
export * from "./IntegrationsSettings.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsSettings.vue?vue&type=style&index=0&id=57d128ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d128ce",
  null
  
)

export default component.exports